module.exports = __webpack_public_path__ + "img/kehushuo-bg_1.55105045.png";